export function formatPrice(amount: string | number, currency = 'EUR'): string {
  const value = typeof amount === 'string' ? parseFloat(amount) : amount
  return new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(value)
}

export function formatDate(
  date: string | Date | null | undefined,
  opts: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' },
): string {
  if (!date) return '—'
  return new Intl.DateTimeFormat('fr-FR', opts).format(new Date(date))
}

export const STATUS_LABELS_FR: Record<string, string> = {
  PENDING: 'En attente',
  QUOTED: 'Devis émis',
  ACCEPTED: 'Acceptée',
  REJECTED: 'Refusée',
  IN_PROGRESS: 'En cours',
  DELIVERED: 'Livrée',
  COMPLETED: 'Terminée',
  CANCELLED: 'Annulée',
  DRAFT: 'Brouillon',
  SENT: 'Envoyé',
  EXPIRED: 'Expiré',
  PENDING_PAYMENT: 'Paiement en attente',
  PAID: 'Payée',
  REFUNDED: 'Remboursée',
  CREATED: 'Créé',
  PROCESSING: 'En traitement',
  SUCCEEDED: 'Réussi',
  FAILED: 'Échec',
}

export const SERVICE_CATEGORY_LABELS: Record<string, string> = {
  CHEF: 'Chef privé',
  CONCIERGE: 'Conciergerie',
  BOAT: 'Bateaux',
  VEHICLE: 'Véhicules',
  WELLNESS: 'Wellness',
  ENTERTAINMENT: 'Divertissement',
  EVENT: 'Événement',
  OTHER: 'Autre',
}

export const PRODUCT_CATEGORY_LABELS: Record<string, string> = {
  WINE: 'Vins & champagne',
  CAVIAR: 'Caviar',
  TRUFFLE: 'Truffe',
  GROCERY: 'Épicerie fine',
  FLOWERS: 'Fleurs',
  TOBACCO: 'Cigares & tabac',
  OTHER: 'Autre',
}

export function statusBadgeVariant(
  status: string,
): 'default' | 'accent' | 'outline' | 'muted' | 'success' | 'warning' | 'danger' {
  switch (status) {
    case 'PENDING':
    case 'CREATED':
    case 'PROCESSING':
    case 'PENDING_PAYMENT':
    case 'DRAFT':
    case 'SENT':
      return 'warning'
    case 'ACCEPTED':
    case 'PAID':
    case 'SUCCEEDED':
    case 'IN_PROGRESS':
    case 'QUOTED':
      return 'accent'
    case 'COMPLETED':
    case 'DELIVERED':
      return 'success'
    case 'REJECTED':
    case 'CANCELLED':
    case 'FAILED':
    case 'REFUNDED':
    case 'EXPIRED':
      return 'danger'
    default:
      return 'muted'
  }
}
